import { render } from "./opencup.vue?vue&type=template&id=23977581"
import script from "./opencup.vue?vue&type=script&lang=js"
export * from "./opencup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__